module.exports = __webpack_public_path__ + "img/tu6.ffa2c9d2.png";